export interface Planet9Sample {
  sample_id: number;
  a_au: number;
  e: number;
  i_deg: number;
  Omega_deg: number;
  omega_deg: number;
  M_deg: number;
  weight: number;
  prior_id: string;
  excluded_by: string[];
  ra_deg: number;
  dec_deg: number;
  distance_au: number;
}

export interface SamplesResponse {
  count: number;
  seed: number;
  priors_used: string[];
  samples: Planet9Sample[];
  cached: boolean;
  disclaimer: string;
}

export interface SkyMapTile {
  ra_deg: number;
  dec_deg: number;
  density: number;
}

export interface ExcludedZone {
  id: string;
  summary: string;
  ra_deg: number | null;
  dec_deg: number | null;
  radius_deg: number | null;
}

export interface SkyMapResponse {
  tile_size_deg: number;
  n_samples: number;
  tiles: SkyMapTile[];
  excluded_zones: ExcludedZone[];
  cached: boolean;
  disclaimer: string;
}

export async function fetchP9Samples(n = 1000, seed = 42): Promise<SamplesResponse> {
  const r = await fetch(`/api/planet9/samples?n=${n}&seed=${seed}`);
  if (!r.ok) throw new Error(`p9/samples HTTP ${r.status}`);
  return r.json();
}

export async function fetchP9SkyMap(
  n = 5000,
  seed = 42,
  tile_size_deg = 2,
): Promise<SkyMapResponse> {
  const r = await fetch(
    `/api/planet9/sky-map?n=${n}&seed=${seed}&tile_size_deg=${tile_size_deg}`,
  );
  if (!r.ok) throw new Error(`p9/sky-map HTTP ${r.status}`);
  return r.json();
}
